// src/pages/steps/PaymentStep.js
import React from "react";
import { useFormContext } from "react-hook-form";
import { FormControl, FormLabel, Input, VStack } from "@chakra-ui/react";

const PaymentStep = () => {
  const { register } = useFormContext();

  return (
    <VStack spacing={4} align="stretch">
      <FormControl>
        <FormLabel>Kortnummer</FormLabel>
        <Input {...register("payment.cardNumber")} placeholder="1234 5678 9012 3456" />
      </FormControl>
      <FormControl>
        <FormLabel>Utløpsdato (MM/YY)</FormLabel>
        <Input {...register("payment.expiry")} placeholder="12/25" />
      </FormControl>
      <FormControl>
        <FormLabel>CVC</FormLabel>
        <Input {...register("payment.cvc")} placeholder="123" />
      </FormControl>
    </VStack>
  );
};

export default PaymentStep;